import { render, staticRenderFns } from "./NotificationsIndex.vue?vue&type=template&id=412bfbbb&scoped=true&"
import script from "./NotificationsIndex.vue?vue&type=script&lang=js&"
export * from "./NotificationsIndex.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsIndex.vue?vue&type=style&index=0&id=412bfbbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412bfbbb",
  null
  
)

export default component.exports